import { serverFetch } from "@core/server";

export function fetchSettings(signal) {
  return serverFetch("settings", {}, signal);
}

export function updateSettings(settings, signal) {
  return serverFetch("settings", { method: "PUT", bodyData: settings }, signal);
}

export function fetchSettingsLookups(signal) {
  return serverFetch("settings/lookups", {}, signal);
}
